/**
 * Image Configuration
 * Centralized image paths and URLs for the application
 * 
 * Usage:
 * import { images } from '@/config/images';
 * <Image src={images.logos.glassX} alt="Logo" />
 */

export const images = {
  // Logos
  logos: {
    glassX: '/glassx-logo.svg',
    glassXAndObservePro: '/GlassXAndObservePro.png',
  },

  // Illustrations
  illustrations: {
    login: '/login-Illustration.svg',
    loginBanner: '/login-banner.svg',
  },

  // Icons (if any static icon images are used)
  icons: {
    faq: '/hover.svg',
    /** Fallback workflow diagram when no scenario-specific image is set. */
    workflow: '/workflow.png',
  },

  /** Images shown when user clicks the workflow icon on each scenario row (Configure → Synthetic → Create Scenarios). */
  workflowScenarios: {
    login: '/login.png',
    plp: '/PLP.png',
    pdp: '/PDP.png',
    addToCart: '/Cart.png',
    checkout: '/Checkout.png',
  },

  // Placeholder images
  placeholders: {
    // Add any placeholder image paths here
  },

};

/**
 * Image dimensions for common use cases
 */
export const imageDimensions = {
  logos: {
    glassX: { width: 112, height: 48 },
    glassXAndObservePro: { width: 200, height: 34 },
  },
  illustrations: {
    login: { width: 200, height: 200 },
    loginBanner: { width: 600, height: 400 },
  },
  avatar: {
    small: { width: 32, height: 32 },
    medium: { width: 48, height: 48 },
    large: { width: 64, height: 64 },
  },
};

